import qs from 'qs'
import { DebtFilter } from '../models'
import axiosClient from './axiosClient'

const PATH = '/debts'

type PayTransaction = {
  cardId: string
  debtId: number
  transactionId: number
  reason: string
}

export const debtApi = {
  getDebts: (debtFilter: DebtFilter) =>
    axiosClient.get(PATH, {
      params: debtFilter,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat' }),
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),

  getDetailDebt: (cardId: string, stationId: number) =>
    axiosClient.get(`${PATH}/detail`, {
      params: {
        cardId,
        stationId,
      },
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat' }),
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),

  pay: (payTransactions: PayTransaction[]) =>
    axiosClient.post(`${PATH}/pay`, payTransactions, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),
}
